import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { fetchUserData, leaveViewDashboardMode } from '../../../store/authorization';
import { Button, Logo, PopOver } from '../../';
import { resetDraft, saveUnSavedDraftAndLogOut } from '../../../store/drafts';
import { useCurrentRole } from '../../../hooks/useCurrentRole';
import { URLS, USER_ROLES } from '../../../constants/constants';
import { LodashHelper } from '../../../utils';
import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation';

const renderHeadersElements = ({
  isMHAdmin,
  canShowRequestRide,
  isMHAdminInViewDashboard,
  location,
  openQuickScheduleNew,
  navigateToCreateRide,
}) => {
  if (isMHAdmin && !isMHAdminInViewDashboard) {
    return <p className={styles.userRole}>Administrator</p>;
  }
  
  if (canShowRequestRide) {
    return (
      <div className={classnames({ [styles.requestRide]: true })}>
        <Button
          myClassName={classnames({
            [styles.requestRideBtn]: true,
            [styles.active]: location?.pathname === URLS.CREATE_RIDE,
          })}
          disabled={location?.pathname === URLS.CREATE_RIDE}
          onClick={isMHAdminInViewDashboard ? openQuickScheduleNew : navigateToCreateRide}>
          Request a Ride
        </Button>
      </div>
    );
  }

  return null;
};

export const Header = ({ user, role, setQuickScheduleVariant }) => {
  const navigate = Navigation();
  const [visible, setVisible] = useState(false);
  const { isMHAdmin, isHOWorker, isDriver, isTCWorker } = useCurrentRole(role);
  const viewDashboardMode = useSelector((state) => state.authorization.viewDashboardMode);
  const isEnterpriseUser = useSelector((state) => state.authorization.isEnterprise);
  const isMHAdminInViewDashboard =
    viewDashboardMode?.active && user?.role !== USER_ROLES.ENTERPRISE_ADMIN &&
    (user?.actualRole === USER_ROLES.SUPER_ADMIN ||
      (user?.onBehalfOfRoleId && !user?.enterpriseLogin));

  const canShowRequestRide =
    (isMHAdminInViewDashboard && !isTCWorker) ||
    (isHOWorker &&
      (role !== USER_ROLES.ENTERPRISE_ADMIN &&
        (!isEnterpriseUser || viewDashboardMode?.active)));
  const dispatch = useDispatch();
  // const { activeTheme, setActiveTheme, themes } = useTheme();

  // Check if we should show the theme selector (only on enterprise.medhaul.link)
  // const showThemeSelector = window.location.hostname.toLowerCase().includes('enterprise.medhaul.link') || 
  //                           window.location.hostname.toLowerCase() === 'localhost' ||
  //                           window.location.hostname.toLowerCase() === '127.0.0.1';

  // const themeOptions = Object.keys(themes).map(key => ({
  //   label: key.charAt(0).toUpperCase() + key.slice(1),
  //   value: key,
  // }));

  // const handleThemeChange = (value) => {
  //   setActiveTheme(value);
  // };


  const handleLogout = useCallback(() => dispatch(saveUnSavedDraftAndLogOut(navigate)), [dispatch]);

  const handleLeaveViewDashboardMode = useCallback(() => { dispatch(leaveViewDashboardMode(navigate)) }, [dispatch, navigate]);

  const handleRedirection = useCallback(() => navigate.push(URLS.RIDES), [navigate]);

  useEffect(() => {
    if (role !== 'RIDER') {
      if (LodashHelper.isEmpty(user) || !role) {
        dispatch(fetchUserData(navigate));
      }
      return;
    }
  }, [user, role, dispatch, navigate]);

  const toggleVisibility = useCallback(() => setVisible(!visible), [visible]);

  const openQuickScheduleNew = useCallback((e) => {
    e?.preventDefault();
    dispatch(resetDraft());
    setQuickScheduleVariant('new');
  }, [dispatch, setQuickScheduleVariant]);

  const navigateToCreateRide = useCallback((e) => {
    e?.preventDefault();
    dispatch(resetDraft());
    navigate.push(URLS.CREATE_RIDE, { from: navigate?.location.pathname });
  }, [dispatch, navigate]);






  return (
    <header
      className={classnames({
        [styles.header]: true,
        [styles.driverHeader]: isDriver,
      })}>
      <Logo
        md
        className={classNames({
          [styles.logoView]: viewDashboardMode?.active,
        })}
        onClick={handleRedirection}
      />
      {viewDashboardMode?.active && <h2 className={styles.viewDashboardTitle}>{viewDashboardMode.organizationName}</h2>}
      {renderHeadersElements({
        isMHAdmin,
        canShowRequestRide,
        isMHAdminInViewDashboard,
        location: navigate?.location,
        openQuickScheduleNew,
        navigateToCreateRide,
      })}

      {/* Theme Selector - Only visible on enterprise.medhaul.link */}
      {/* {showThemeSelector && (
        <div className={styles.themeSelector}>
          <Select
            value={activeTheme}
            onChange={handleThemeChange}
            options={themeOptions}
            className={styles.themeDropdown}
            popupClassName={styles.themeDropdownPopup}
            placeholder="Select Theme"
            style={{ minWidth: 120 }}
          />
        </div>
      )} */}

      {/* Render the modal */}


      {role !== 'RIDER' &&
        <PopOver
          role={role}
          user={user}
          visible={visible}
          viewDashboardMode={viewDashboardMode?.active}
          handleLeaveViewDashboardMode={handleLeaveViewDashboardMode}
          handleLogout={handleLogout}
          toggleVisibility={toggleVisibility}
        />
      }
    </header>
  );
};

Header.propTypes = {
  user: PropTypes.object,
  role: PropTypes.string,
};